










































import { Component, Ref, Vue, Emit } from 'vue-property-decorator';
import { associationAgree, associationTerminated, associationEdit } from '@/utils/supplier';
@Component({
  components: {},
})
export default class DictListView extends Vue {
  drawer: boolean = false;
  ruleForm: object = {};
  checked: boolean = false;
  type: string = '';
  direction: string = 'rtl';
  loading:boolean = false;
  refuseLoading:boolean = false
  //  初始化
  init(val, code) {
    this.type = code;
    this.drawer = true;
    this.ruleForm = val;
  }
  // 拒绝
  refuse() {
    this.loading = true
    associationEdit(this.ruleForm).then((res) => {
      this.drawer = false;
      this.$message.success('已拒绝');
      this.$parent['onSubmit']('init');
      this.loading = false
    });
  }
  // 开始合作
  onSubmit() {
    this.loading = true
    associationAgree(this.ruleForm).then((res) => {
      this.drawer = false;
      this.$message.success('开启合作');
      this.$parent['onSubmit']('init');
      this.checked = false;
      this.loading = false
    });
  }
  handleClose(done) {
    this.$confirm('确定关闭吗？')
      .then((_) => {
        done();
      })
      .catch((_) => {});
  }
}
